/* HoldFit UAE theme - vanilla JS, no dependencies.
   Security notes: no dynamic code execution, no HTML-string injection (server HTML is parsed with
   DOMParser and nodes are imported), no inline handlers, no browser storage, and all navigation
   targets are same-origin constants from window.hfConfig (Shopify `routes`). */
(function () {
  'use strict';

  var cfg = window.hfConfig || { routes: {}, cartType: 'drawer' };
  var R = cfg.routes || {};
  var S = cfg.strings || {};
  function str(k, d) { return S[k] || d; }
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastTrigger = null;

  /* ---------- helpers ---------- */
  function go(url) { if (typeof cfg.navigate === 'function') cfg.navigate(url); else window.location.assign(url); }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function sameOriginPath(p) { return typeof p === 'string' && p.charAt(0) === '/' && p.charAt(1) !== '/'; }
  function jsonFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) { var e = new Error(data.description || data.message || str('error', 'Something went wrong. Please try again.')); e.data = data; throw e; }
        return data;
      });
    });
  }

  /* ---------- dialogs (cart drawer, mobile menu) ---------- */
  function openDialog(el, trigger) {
    if (!el) return false;
    if (typeof el.showModal !== 'function') return false;
    lastTrigger = trigger || document.activeElement;
    if (!el.open) el.showModal();
    document.documentElement.style.overflow = 'hidden';
    return true;
  }
  function closeDialog(el) {
    if (el && el.open) el.close();
  }
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('dialog[data-hf-dialog]')) {
      document.documentElement.style.overflow = '';
      if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus(); } catch (err) { /* ignore */ } }
    }
  }, true);
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-hf-open-dialog]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-hf-open-dialog'));
      if (openDialog(d, open)) e.preventDefault();
      return;
    }
    var close = e.target.closest('[data-hf-close-dialog]');
    if (close) { closeDialog(close.closest('dialog')); return; }
    if (e.target.matches && e.target.matches('dialog[data-hf-dialog]')) { closeDialog(e.target); } // backdrop click
    var cartLink = e.target.closest('[data-hf-cart-link]');
    if (cartLink && cfg.cartType === 'drawer' && !e.metaKey && !e.ctrlKey) {
      var drawer = $('[data-hf-cart-drawer]');
      if (drawer && openDialog(drawer, cartLink)) e.preventDefault();
    }
    // close sub-nav and filter panel when clicking outside
    if (!e.target.closest('.hf-nav-item.has-sub')) { $$('[data-hf-sub-toggle][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
    var fd = $('[data-hf-filter-details][open]');
    if (fd && !e.target.closest('[data-hf-filter-details]')) fd.removeAttribute('open');
  });

  /* ---------- desktop sub-menus ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hf-sub-toggle]');
    if (!t) return;
    t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-hf-sub-toggle][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); });
    var fd = $('[data-hf-filter-details][open]'); if (fd) { fd.removeAttribute('open'); var s = $('summary', fd); if (s) s.focus(); }
    var sp = $('[data-hf-search-panel]'); if (sp && !sp.hidden) toggleSearch(false);
  });

  /* ---------- search panel + predictive search ---------- */
  var searchPanel = $('[data-hf-search-panel]');
  var searchToggle = $('[data-hf-search-toggle]');
  var searchInput = $('[data-hf-search-input]');
  var predictiveBox = $('[data-hf-predictive]');
  var aborter = null;

  function toggleSearch(show) {
    if (!searchPanel || !searchToggle) return;
    searchPanel.hidden = !show;
    searchToggle.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show && searchInput) searchInput.focus();
    if (!show) searchToggle.focus();
  }
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function (e) { e.preventDefault(); toggleSearch(searchPanel.hidden); });
  }
  function runPredictive(q) {
    if (!predictiveBox || !R.predictiveSearch) return;
    if (aborter) aborter.abort();
    if (q.length < 2) { predictiveBox.replaceChildren(); return; }
    aborter = new AbortController();
    var url = R.predictiveSearch + '?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search&resources[type]=product,collection,page,query&resources[limit]=4&resources[options][unavailable_products]=last';
    fetch(url, { signal: aborter.signal, headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var src = doc.querySelector('#shopify-section-predictive-search') || doc.body;
        predictiveBox.replaceChildren.apply(predictiveBox, Array.prototype.map.call(src.childNodes, function (n) { return document.importNode(n, true); }));
      })
      .catch(function (err) { if (err.name !== 'AbortError') predictiveBox.replaceChildren(); });
  }
  if (searchInput) {
    searchInput.addEventListener('input', debounce(function () { runPredictive(searchInput.value.trim()); }, 250));
  }

  /* ---------- announcement rotator (narrow screens only show one at a time) ---------- */
  $$('[data-hf-rotator]').forEach(function (box) {
    var items = $$('.hf-announce-item', box);
    if (items.length < 2 || reduceMotion) return;
    var i = 0, paused = false;
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('focusin', function () { paused = true; });
    box.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- sale timer (REAL end time only; disappears when finished) ---------- */
  $$('[data-hf-timer]').forEach(function (el) {
    var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
    if (!end) { el.remove(); return; }
    var d = $('[data-hf-d]', el), h = $('[data-hf-h]', el), m = $('[data-hf-m]', el), s = $('[data-hf-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.remove(); return false; }
      d.textContent = Math.floor(left / 86400);
      h.textContent = pad(Math.floor(left % 86400 / 3600));
      m.textContent = pad(Math.floor(left % 3600 / 60));
      s.textContent = pad(left % 60);
      return true;
    }
    if (tick()) { var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000); }
  });

  /* ---------- cart: shared rendering ---------- */
  function sectionIds() {
    var ids = [];
    if ($('[data-hf-cart-drawer]')) ids.push('cart-drawer');
    var page = $('[data-hf-cart-page]');
    if (page && page.getAttribute('data-section-id')) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }
  function setCartCount(n, label) {
    $$('[data-hf-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !(n > 0); });
    if (label) $$('[data-hf-cart-link]').forEach(function (a) { a.setAttribute('aria-label', label); });
  }
  function renderSections(sections) {
    if (!sections) return;
    var drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      var dDoc = parseHTML(drawerHtml);
      var newInner = dDoc.querySelector('.hf-drawer-inner');
      var newDrawer = dDoc.querySelector('[data-hf-cart-drawer]');
      var curInner = $('[data-hf-cart-drawer] .hf-drawer-inner');
      if (newInner && curInner) {
        curInner.replaceWith(document.importNode(newInner, true));
        var count = newDrawer ? parseInt(newDrawer.getAttribute('data-item-count'), 10) || 0 : 0;
        $('[data-hf-cart-drawer]').setAttribute('data-item-count', count);
        setCartCount(count, newDrawer ? newDrawer.getAttribute('data-cart-label') : '');
      }
    }
    var page = $('[data-hf-cart-page]');
    if (page) {
      var pid = page.getAttribute('data-section-id');
      if (pid && sections[pid]) {
        var pDoc = parseHTML(sections[pid]);
        var np = pDoc.querySelector('[data-hf-cart-page]');
        if (np) page.replaceWith(document.importNode(np, true));
      }
    }
  }
  function showCartError(scope, msg) {
    var box = (scope && $('[data-hf-cart-error]', scope)) || $('[data-hf-cart-error]');
    if (!box) return;
    box.textContent = msg; box.hidden = !msg;
  }
  function setLoading(scope, on) {
    if (!scope) return;
    scope.setAttribute('aria-busy', on ? 'true' : 'false');
    var l = $('[data-hf-loading]', scope);
    if (l) l.hidden = !on;
  }
  function cartRequest(url, body, scope) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    setLoading(scope, true);
    return jsonFetch(url + '.js', body).then(function (data) {
      renderSections(data.sections);
      setLoading(scope, false);
      return data;
    }).catch(function (err) { setLoading(scope, false); showCartError(scope, err.message); throw err; });
  }

  /* ---------- add to cart / buy now ---------- */
  function formButtons(form) {
    var list = $$('button', form);
    if (form.id) list = list.concat($$('[form="' + form.id + '"]'));
    return list;
  }
  function setBusy(form, on) {
    if (on) form.setAttribute('data-busy', '1'); else form.removeAttribute('data-busy');
    formButtons(form).forEach(function (b) {
      if (b.hasAttribute('data-hf-add-btn') || b.hasAttribute('data-hf-buy-now')) {
        if (on) { b.setAttribute('aria-busy', 'true'); b.setAttribute('data-was-disabled', b.disabled ? '1' : ''); b.disabled = true; }
        else { b.removeAttribute('aria-busy'); b.disabled = b.getAttribute('data-was-disabled') === '1'; b.removeAttribute('data-was-disabled'); }
      }
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-type="hf-add"]') : null;
    if (!form || !window.fetch) return; // no-JS / old browser: normal Shopify form post
    e.preventDefault();
    if (form.getAttribute('data-busy')) return; // blocks duplicate requests
    var submitter = e.submitter;
    var buyNow = !!(submitter && submitter.hasAttribute('data-hf-buy-now'));
    var idEl = form.elements.id, qtyEl = form.elements.quantity;
    var id = idEl ? parseInt(idEl.value, 10) : NaN;
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    if (!id) return;
    var scope = form.closest('[data-hf-product]') || (form.hasAttribute('data-hf-addon') ? (form.closest('.hf-drawer-inner, [data-hf-cart-page]') || form) : form);
    showCartError(scope, '');
    setBusy(form, true);
    var req = buyNow
      ? (setLoading(scope, true), jsonFetch(R.cartAdd + '.js', { id: id, quantity: qty }).catch(function (err) { setLoading(scope, false); showCartError(scope, err.message); throw err; }))
      : cartRequest(R.cartAdd, { id: id, quantity: qty }, scope);
    req.then(function () {
      if (buyNow) { go(R.checkout); return; }
      setBusy(form, false);
      if (form.hasAttribute('data-hf-addon')) return; // add-on from inside the cart: the cart already refreshed
      var drawer = $('[data-hf-cart-drawer]');
      if (cfg.cartType === 'drawer' && drawer && openDialog(drawer, submitter || document.activeElement)) return;
      go(R.cart);
    }).catch(function () { setBusy(form, false); });
  });

  /* cart add-on slider arrows */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-hf-slide]') : null;
    if (!b) return;
    var box = b.closest('[data-hf-addons]'), track = box && $('[data-hf-addons-track]', box);
    if (!track) return;
    var dir = parseInt(b.getAttribute('data-hf-slide'), 10) || 1;
    if (window.getComputedStyle(track).direction === 'rtl') dir = -dir;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  // Back/forward cache: never leave buttons locked after returning from checkout
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) $$('form[data-type="hf-add"][data-busy]').forEach(function (f) { setBusy(f, false); });
  });

  /* ---------- cart lines (drawer + page) ---------- */
  function changeLine(line, qty, scope) {
    return cartRequest(R.cartChange, { line: line, quantity: qty }, scope).catch(function () { /* error already shown */ });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-hf-line-step]');
    if (step) {
      var line = parseInt(step.getAttribute('data-line'), 10);
      var input = $('[data-hf-line-input][data-line="' + line + '"]', step.closest('[data-hf-lines]'));
      var next = Math.max(0, (parseInt(input && input.value, 10) || 0) + parseInt(step.getAttribute('data-hf-line-step'), 10));
      changeLine(line, next, step.closest('.hf-drawer-inner, [data-hf-cart-page]'));
      return;
    }
    var rm = e.target.closest('[data-hf-remove]');
    if (rm && window.fetch) {
      e.preventDefault();
      changeLine(parseInt(rm.getAttribute('data-line'), 10), 0, rm.closest('.hf-drawer-inner, [data-hf-cart-page]'));
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest ? e.target.closest('[data-hf-line-input]') : null;
    if (inp && window.fetch) {
      changeLine(parseInt(inp.getAttribute('data-line'), 10), Math.max(0, parseInt(inp.value, 10) || 0), inp.closest('.hf-drawer-inner, [data-hf-cart-page]'));
    }
    var auto = e.target.closest ? e.target.closest('[data-hf-autosubmit]') : null;
    if (auto && auto.form) { if (auto.form.requestSubmit) auto.form.requestSubmit(); else auto.form.submit(); }
  });

  /* ---------- discount code (navigates to Shopify's own /discount/ route) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hf-discount-apply]');
    if (!btn) return;
    var input = $('[data-hf-discount-input]');
    var msg = $('[data-hf-discount-msg]');
    var code = input ? input.value.trim() : '';
    if (!/^[A-Za-z0-9_\-]{1,60}$/.test(code)) {
      if (msg) { msg.hidden = false; msg.textContent = str('discountInvalid', 'Please enter a valid discount code.'); }
      return;
    }
    go((R.root || '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart || '/cart'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-hf-discount-input]')) { e.preventDefault(); var b = $('[data-hf-discount-apply]'); if (b) b.click(); }
  });

  /* ---------- product page ---------- */
  $$('[data-hf-product]').forEach(function (root) {
    var vjson = $('script[data-hf-variants]');
    if (!vjson) return;
    var variants;
    try { variants = JSON.parse(vjson.textContent); } catch (err) { return; }
    var form = $('form[data-type="hf-add"]', root);
    var idInput = $('[data-hf-variant-id]', root);
    var priceEl = $('[data-hf-price]', root), compareEl = $('[data-hf-compare]', root), saveEl = $('[data-hf-save]', root);
    var qtyInput = $('[data-hf-qty]', root);
    var sticky = $('[data-hf-sticky]');
    var stickyPrice = $('[data-hf-sticky-price]'), stickyQty = $('[data-hf-sticky-qty]');
    var options = $$('[data-hf-option]', root);
    var track = $('[data-hf-gallery-track]', root);
    var thumbs = $$('[data-hf-thumb]', root);
    var current = null;

    function ctaBtns(sel) {
      var list = form ? $$(sel, form) : [];
      if (form && form.id) list = list.concat($$(sel + '[form="' + form.id + '"]'));
      return list;
    }
    function selected() { return options.map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }); }
    function findVariant(vals) {
      if (!options.length) return variants[0];
      return variants.filter(function (v) { return vals.every(function (val, i) { return v.options[i] === val; }); })[0] || null;
    }
    function markSoldOut(vals) {
      options.forEach(function (f, oi) {
        $$('input', f).forEach(function (inp) {
          var test = vals.slice(); test[oi] = inp.value;
          var ok = variants.some(function (v) { return v.available && test.every(function (t, i) { return v.options[i] === t; }); });
          var lab = $('label[for="' + inp.id + '"]', f);
          if (lab) lab.classList.toggle('is-soldout', !ok);
        });
      });
    }
    function scrollToImage(i) {
      if (!track || i == null) return;
      var slide = $('[data-index="' + i + '"]', track);
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function updateQtyUI() {
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      if (stickyQty) { stickyQty.hidden = q < 2; stickyQty.textContent = q > 1 ? '\u00d7 ' + q : ''; }
    }
    function clampQty() {
      if (!qtyInput) return;
      var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (current && current.max != null && current.max > 0) q = Math.min(q, current.max);
      qtyInput.value = q; updateQtyUI();
    }
    function apply(v, vals) {
      current = v;
      var avail = !!(v && v.available);
      if (idInput && v) idInput.value = v.id;
      if (v && priceEl) priceEl.textContent = v.price;
      if (v && stickyPrice) stickyPrice.textContent = v.price;
      var skuEl = $('[data-hf-sku]', root);
      if (skuEl) { skuEl.textContent = v && v.sku ? v.sku : ''; if (skuEl.parentNode) skuEl.parentNode.hidden = !(v && v.sku); }
      var avEl = $('[data-hf-availability]', root);
      if (avEl) avEl.textContent = !v ? str('unavailable', 'Unavailable') : (avail ? str('available', 'Available') : str('soldOut', 'Sold out'));
      if (compareEl) { compareEl.hidden = !(v && v.compare); if (v && v.compare) { compareEl.lastChild.textContent = v.compare; } }
      if (saveEl) { saveEl.hidden = !(v && v.save); if (v && v.save) saveEl.textContent = str('save', 'Save __PCT__%').replace('__PCT__', v.save); }
      if (priceEl) priceEl.classList.toggle('is-sale', !!(v && v.compare));
      ctaBtns('[data-hf-add-btn]').forEach(function (b) { if (!b.hasAttribute('aria-busy')) b.disabled = !avail; var l = $('[data-hf-add-label]', b); if (l) l.textContent = !v ? str('unavailable', 'Unavailable') : (avail ? str('addToCart', 'Add to cart') : str('soldOut', 'Sold out')); });
      ctaBtns('[data-hf-buy-now]').forEach(function (b) { if (!b.hasAttribute('aria-busy')) b.disabled = !avail; });
      options.forEach(function (f, i) { var l = $('[data-hf-option-label]', f); if (l) l.textContent = vals[i] || ''; });
      markSoldOut(vals);
      if (v) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (err) { /* ignore */ }
        scrollToImage(v.image);
      }
      clampQty();
    }
    options.forEach(function (f) { f.addEventListener('change', function () { var vals = selected(); apply(findVariant(vals), vals); }); });
    var vals0 = selected(); current = findVariant(vals0); markSoldOut(vals0); clampQty();

    $$('[data-hf-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-hf-qty-step'), 10));
        clampQty();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    /* gallery */
    thumbs.forEach(function (t) { t.addEventListener('click', function () { scrollToImage(parseInt(t.getAttribute('data-hf-thumb'), 10)); }); });
    if (track && thumbs.length) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { track.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * track.clientWidth, behavior: 'smooth' }); e.preventDefault(); }
      });
    }

    /* sticky mobile buy bar: shown only while the main buttons are off-screen */
    var cta = $('[data-hf-cta]', root);
    if (sticky && cta && typeof window.IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.hidden = !show;
        document.body.classList.toggle('has-sticky-buy', show);
      }, { threshold: 0 }).observe(cta);
    }
  });

  /* ---------- related products (Shopify recommendations, falls back to server-rendered list) ---------- */
  $$('[data-hf-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url');
    if (!sameOriginPath(url) || !window.fetch) return;
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('rec'); return r.text(); })
      .then(function (html) {
        var doc = parseHTML(html);
        var fresh = doc.querySelector('[data-hf-recommendations]');
        if (fresh && fresh.querySelector('.hf-related')) box.replaceChildren.apply(box, Array.prototype.map.call(fresh.childNodes, function (n) { return document.importNode(n, true); }));
      })
      .catch(function () { /* keep the server-rendered list */ });
  });

  /* ---------- header shadow once the page is scrolled (passive, throttled with rAF) ---------- */
  (function () {
    var header = $('[data-hf-header]');
    if (!header) return;
    var ticking = false;
    function update() { header.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    update();
  })();

  /* ---------- product reviews: filter, sort, load more, helpful, photo lightbox, write-a-review ---------- */
  $$('[data-hf-reviews]').forEach(function (root) {
    var list = $('[data-hf-rv-list]', root);
    var cards = list ? $$('[data-hf-rv-card]', list) : [];
    var initial = parseInt(root.getAttribute('data-initial'), 10) || 4;
    var visible = initial, filter = 'all', sort = 'newest';
    var more = $('[data-hf-rv-more]', root), statusEl = $('[data-hf-rv-status]', root), noMatch = $('[data-hf-rv-nomatch]', root);
    var statusTpl = root.getAttribute('data-status') || '';
    function num(c, k) { return parseFloat(c.getAttribute(k)) || 0; }
    function matches(c) {
      if (filter === 'all') return true;
      if (filter === 'photos') return c.getAttribute('data-photos') === '1';
      var r = num(c, 'data-rating');
      return filter === 'low' ? r <= 2 : r === parseInt(filter, 10);
    }
    function render() {
      if (!list) return;
      var order = cards.slice().sort(function (a, b) {
        var d = 0;
        if (sort === 'top') d = num(b, 'data-rating') - num(a, 'data-rating');
        else if (sort === 'low') d = num(a, 'data-rating') - num(b, 'data-rating');
        else if (sort === 'helpful') d = num(b, 'data-helpful') - num(a, 'data-helpful');
        return d || (num(a, 'data-order') - num(b, 'data-order'));
      });
      var total = 0, shown = 0;
      order.forEach(function (c) {
        list.appendChild(c);
        if (matches(c)) { total++; if (total <= visible) { c.hidden = false; shown++; } else { c.hidden = true; } }
        else { c.hidden = true; }
      });
      if (more) more.hidden = shown >= total;
      if (noMatch) noMatch.hidden = total > 0;
      if (statusEl && statusTpl) statusEl.textContent = statusTpl.replace('__S__', shown).replace('__T__', total);
    }
    $$('[data-hf-rv-filter]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('[data-hf-rv-filter]', root).forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
        chip.classList.add('is-active'); chip.setAttribute('aria-pressed', 'true');
        filter = chip.getAttribute('data-hf-rv-filter'); visible = initial; render();
      });
    });
    var sel = $('[data-hf-rv-sort]', root);
    if (sel) sel.addEventListener('change', function () { sort = sel.value; visible = initial; render(); });
    if (more) more.addEventListener('click', function () { visible += initial; render(); });
    render();

    root.addEventListener('click', function (e) {
      var h = e.target.closest ? e.target.closest('[data-hf-rv-helpful]') : null;
      if (h) {
        var cEl = $('[data-hf-rv-helpful-count]', h), card = h.closest('[data-hf-rv-card]');
        var on = !h.classList.contains('is-active'), n = (parseInt(cEl.textContent, 10) || 0) + (on ? 1 : -1);
        h.classList.toggle('is-active', on); h.setAttribute('aria-pressed', on ? 'true' : 'false');
        cEl.textContent = n; if (card) card.setAttribute('data-helpful', n);
      }
    });

    /* header rating next to the product title: use the section's numbers (entries + manual blocks) */
    var hdr = $('[data-hf-pdp-rating]'), avg10 = parseInt(root.getAttribute('data-avg10'), 10);
    if (hdr && avg10 > 0) {
      $$('.hf-star-slot', hdr).forEach(function (slot, i) {
        var on = avg10 >= (i + 1) * 10 - 5, a = $('.hf-star-on', slot), b = $('.hf-star-off', slot);
        if (a) a.hidden = !on; if (b) b.hidden = on;
      });
      var numEl = $('[data-hf-pdp-num]', hdr), cntEl = $('[data-hf-pdp-count]', hdr), starsEl = $('[data-hf-pdp-stars]', hdr);
      if (numEl) numEl.textContent = root.getAttribute('data-avg') || '';
      if (cntEl) cntEl.textContent = root.getAttribute('data-count-label') || '';
      if (starsEl) starsEl.setAttribute('aria-label', root.getAttribute('data-stars-label') || '');
      hdr.hidden = false;
    }

    var box = $('[data-hf-rv-lightbox]', root), lbImg = $('[data-hf-rv-lb-img]', root);
    if (box && lbImg && typeof box.showModal === 'function') {
      $$('[data-hf-rv-photo]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var src = b.getAttribute('data-full');
          if (!src || src.indexOf('https://') !== 0) return;
          lbImg.src = src; lbImg.alt = b.getAttribute('data-alt') || ''; box.showModal();
        });
      });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    }

    var wrap = $('[data-hf-rv-formwrap]', root);
    function openForm(focus) {
      if (!wrap) return;
      wrap.classList.add('is-open');
      wrap.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      var first = focus ? $('input[type=radio], input[type=text]', wrap) : null;
      if (first) { try { first.focus({ preventScroll: true }); } catch (err) { /* ignore */ } }
    }
    $$('[data-hf-rv-open]', root).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openForm(true); }); });
    if (wrap && ($('[data-hf-rv-posted]', wrap) || $('[data-hf-rv-error]', wrap) || window.location.hash === '#write-review')) openForm(false);
  });

  /* ---------- misc ---------- */
  var f = $('[data-hf-focus]'); if (f) { try { f.focus(); } catch (err) { /* ignore */ } }
})();
